import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Pencil, Trash2, ShoppingBasket } from "lucide-react";
import { toast } from "sonner";
import api, { TRY, trDate, formatApiError, trWeekday } from "@/lib/api";
import { Card } from "@/components/Cards";
import { Input } from "@/components/ui/input";

const shift = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x.toISOString().slice(0, 10); };

export default function DailyPurchaseList({ date, setDate, supplierId, onEdit, refreshKey }) {
  const [rows, setRows] = useState([]);
  const load = async () => {
    const r = await api.get("/supplier-purchases/daily", { params: { date, ...(supplierId ? { supplier_id: supplierId } : {}) } });
    setRows(r.data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [date, supplierId, refreshKey]);
  const del = async (id) => {
    try { await api.delete(`/supplier-ledger/${id}`); toast.success("Alım silindi"); load(); onEdit?.(null, true); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const total = rows.reduce((s, r) => s + r.amount, 0);

  return (
    <Card className="p-5" data-testid="daily-purchase-list">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
        <div>
          <h3 className="font-heading text-lg font-semibold flex items-center gap-2"><ShoppingBasket className="h-5 w-5 text-primary" /> Günlük Alımlar</h3>
          <p className="text-xs text-muted-foreground mt-0.5">{trDate(date)} · {rows.length} kayıt · Toplam <span className="font-mono font-semibold text-foreground" data-testid="daily-purchase-day-total">{TRY(total)}</span></p>
        </div>
        <div className="flex items-center gap-1">
          <button onClick={() => setDate(shift(date, -1))} data-testid="daily-purchase-prev" className="h-9 w-9 rounded-lg hover:bg-accent inline-flex items-center justify-center"><ChevronLeft className="h-4 w-4" /></button>
          <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="daily-purchase-list-date" className="h-9 w-40 font-mono" />
          <span className="text-xs text-muted-foreground font-medium" data-testid="daily-purchase-list-weekday">{trWeekday(date)}</span>
          <button onClick={() => setDate(shift(date, 1))} data-testid="daily-purchase-next" className="h-9 w-9 rounded-lg hover:bg-accent inline-flex items-center justify-center"><ChevronRight className="h-4 w-4" /></button>
        </div>
      </div>
      {rows.length === 0 ? <div className="py-8 text-center text-sm text-muted-foreground" data-testid="daily-purchase-empty">Bu tarihte günlük alım yok</div> : (
        <div className="space-y-3">
          {rows.map((r) => (
            <div key={r.id} className="rounded-xl border border-border p-3" data-testid={`daily-purchase-row-${r.id}`}>
              <div className="flex items-center justify-between gap-2">
                <div className="font-semibold">{r.supplier_name}</div>
                <div className="flex items-center gap-2">
                  <span className="font-mono font-bold text-rose-400">{TRY(r.amount)}</span>
                  <button onClick={() => onEdit(r)} data-testid={`daily-purchase-edit-${r.id}`} className="h-7 w-7 rounded-md hover:bg-accent inline-flex items-center justify-center text-muted-foreground"><Pencil className="h-3.5 w-3.5" /></button>
                  <button onClick={() => del(r.id)} data-testid={`daily-purchase-delete-${r.id}`} className="h-7 w-7 rounded-md hover:bg-destructive/10 inline-flex items-center justify-center text-muted-foreground hover:text-destructive"><Trash2 className="h-3.5 w-3.5" /></button>
                </div>
              </div>
              <div className="mt-2 flex flex-wrap gap-2">
                {r.items.map((i, idx) => (
                  <span key={idx} className="rounded-full bg-muted px-2.5 py-1 text-xs font-mono">{i.name} <b>x{i.qty}</b> · {TRY(i.total)}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
